import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=0f8786a5&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=0f8786a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8786a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8786a5')) {
      api.createRecord('0f8786a5', component.options)
    } else {
      api.reload('0f8786a5', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=0f8786a5&scoped=true&", function () {
      api.rerender('0f8786a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bYpL9Coyj52H/JS/comp/GuestBoxKids.vue"
export default component.exports